import IztLevel from './src/izt-level'

IztLevel.install = Vue => {
  Vue.component(IztLevel.name, IztLevel)
}

export default IztLevel